export { BaselineComponent } from './baseline.component';
export { Remediate } from './remediate';
export const href =
    'https://docs.microsoft.com/en-us/microsoft-365/solutions/best-practices-anonymous-sharing?view=o365-worldwide#set-an-expiration-date-for-anyone-links';
